import { Action } from "@ngrx/store";
import { ReduxAction } from "./redux.action";
import {FacilityModel} from "../models/location.model";

export class SetLocationInfo implements ReduxAction {
  type: string = "SET_LOCATION_MODAL";
  location: FacilityModel;

  constructor(location: FacilityModel) {
    this.location = location;
  }

  get() {
    return this.location;
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/actions/location.actions.ts